var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 2C0.447777 2 6.13206e-05 2.44772 6.13689e-05 3L6.10352e-05 21C6.10834e-05 21.5523 0.447777 22 1.00006 22L22.0001 22C22.5523 22 23.0001 21.5523 23.0001 21C23.0001 20.4477 22.5523 20 22.0001 20H2.00006L2.00006 3C2.00006 2.44772 1.55235 2 1.00006 2Z",
    fill: "#4F49DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.737 16.8815C13.3346 16.9593 12.919 17 12.4939 17C12.1917 17 11.8942 16.9794 11.6029 16.9396C11.8544 16.3431 11.9934 15.6878 11.9934 15L11.9934 14.9727C11.9805 12.5713 10.2731 10.5705 8.00496 10.1031C7.67681 10.0355 7.33691 10 6.98871 10C6.65026 10 6.31966 10.0336 6.00006 10.0975C6.04485 9.36509 6.21104 8.66542 6.4788 8.01835C7.45484 5.65965 9.78038 4 12.4939 4C16.0872 4 19.0001 6.91015 19.0001 10.5C19.0001 13.6651 16.7356 16.3019 13.737 16.8815ZM13.9889 14.7465C15.7435 14.1305 17.0001 12.4608 17.0001 10.5C17.0001 8.0165 14.9844 6 12.4939 6C10.8495 6 9.4115 6.87969 8.62465 8.19197C11.624 8.90921 13.8753 11.5548 13.9889 14.7465Z",
    fill: "#4F49DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 15C10.0001 16.6569 8.65692 18 7.00006 18C5.34321 18 4.00006 16.6569 4.00006 15C4.00006 13.3431 5.34321 12 7.00006 12C8.65692 12 10.0001 13.3431 10.0001 15ZM8.00006 15C8.00006 15.5523 7.55235 16 7.00006 16C6.44778 16 6.00006 15.5523 6.00006 15C6.00006 14.4477 6.44778 14 7.00006 14C7.55235 14 8.00006 14.4477 8.00006 15Z",
    fill: "#4F49DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsCampaigns);
export default __webpack_public_path__ + "static/media/smsCampaigns.9c57a02b.svg";
export { ForwardRef as ReactComponent };